import DaySlider from './DaySlider';
export default DaySlider;
